import { useLifetimeRaised } from "@playlive/react-query";

/**
 * Charity-setup adapter over `@playlive/react-query#useLifetimeRaised`.
 *
 * The lib hook owns the fetch, cache key, and poll cadence (60 s). This
 * wrapper maps the `"n/a"` sentinel onto the lib's nullish-slug
 * auto-disable and reports the sentinel amounts `TiltifyProfileCard`
 * expects: `-1` for "not fetched yet", `0` for "no history".
 */
export function useTiltifyLifetimeRaised({
  tiltifySlug,
  isTeam = false,
}: {
  tiltifySlug: string;
  isTeam?: boolean;
}) {
  const enabled = tiltifySlug !== "n/a";

  const { data, isLoading, isFetching, error } = useLifetimeRaised(
    {
      username: enabled ? tiltifySlug : null,
      isTeam,
    },
    { refetchInterval: false },
  );

  return {
    amountRaised: data === undefined ? -1 : (data ?? 0),
    isLoading,
    isFetching,
    isError: error !== null,
  };
}
